// src/components/Footer.jsx  (replace file)
import React from "react";
import { NavLink } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container-tight">
        <div className="footer-grid">
          <section>
            <h3 className="h3">A &amp; M Audio</h3>
            <p className="small muted">
              Veteran-owned car audio installs. Clean wiring, precise tuning.
            </p>
          </section>

          <nav aria-label="Footer" className="footer-nav">
            <h4 className="h3">Explore</h4>
            <ul className="footer-links">
              <li><NavLink className="link" to="/services">Services</NavLink></li>
              <li><NavLink className="link" to="/gallery">Gallery</NavLink></li>
              <li><NavLink className="link" to="/about">About</NavLink></li>
              <li><NavLink className="link" to="/contact">Contact</NavLink></li>
            </ul>
          </nav>

          <section>
            <h4 className="h3">Contact</h4>
            <address className="small muted" style={{ fontStyle: "normal" }}>
              Columbus, OH<br />
              <a className="link" href="mailto:austinlm132@gmail.com">
                austinlm132@gmail.com
              </a>
            </address>
          </section>
        </div>

        <div className="footer-bottom small muted">
          © {year} A &amp; M Audio
        </div>
      </div>
    </footer>
  );
}
